export default __webpack_public_path__ + "static/card-1-629d866d00fd27e41a5b1ce4d8bc455b.png";